import { CommerceQuotation } from './components';

export const StepFour = () => <CommerceQuotation />;
